var adaptPriceFilter = function adaptPriceFilter(price) {
  var priceValue = Number(price) * 100;
  return Math.round(priceValue * 100) / 100;
};
export default adaptPriceFilter;